module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-box"
  }, [_c('div', {
    staticClass: "panel-head text-center padding-a-xs"
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n    "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.details.upDownstairs && !_vm.rsvp.isAsap),
      expression: "!!details.upDownstairs && !rsvp.isAsap"
    }]
  }, [_vm._v("(" + _vm._s(_vm.details.upDownstairs) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body padding-a-m"
  }, [_c('ul', {
    staticClass: "unstyled margin-a-z"
  }, [_vm._l((_vm.details), function(value, index) {
    return (_vm.isExtraStop) ? _c('li', {
      key: index,
      staticClass: "padding-l-m margin-b-s"
    }, [_c('span', {
      staticClass: "panel-icon"
    }, [_c('icon', {
      staticClass: "margin-r-xs",
      attrs: {
        "name": _vm.panelIcon('location')
      }
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "panel-text"
    }, [_vm._v(_vm._s(value.location))])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.details), function(value, index) {
    return (index !== 'upDownstairs' && !_vm.isExtraStop) ? _c('li', {
      key: (index + "p"),
      staticClass: "padding-l-m margin-b-s"
    }, [_c('span', {
      staticClass: "panel-icon"
    }, [_c('icon', {
      staticClass: "margin-r-xs",
      attrs: {
        "name": _vm.panelIcon(index)
      }
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "panel-text"
    }, [_vm._v(_vm._s(value))])]) : _vm._e()
  }), _vm._v(" "), (_vm.isDropoff) ? _c('li', [_c('small', [_c('i', [_vm._v(_vm._s(_vm.$t('global.dropoffEstimate')))])])]) : _vm._e()], 2)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-cb2a6798", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb2a6798","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Global/PanelLocationDetails.vue
// module id = 2142
// module chunks = 0